import * as yup from 'yup';

export const FIELD_ID = 'application';
// export const FIELD_POINT = 'score';
export const FIELD_DESCRIPTION = 'description';

export const AppealsConfirmValidationForm = yup.object().shape({
  // [FIELD_ID]: yup.number().required('error.required'),
  // [FIELD_POINT]: yup.number().required('error.required'),
  [FIELD_DESCRIPTION]: yup.string().required('error.required').trim(),
});
